//basic validation to cut down on API calls

export function basicPhoneNumberValidation(phoneNumber: string): boolean {
  // Check the length of the cleaned number
  if (phoneNumber.length < 7 || phoneNumber.length > 15) {
    return false;
  }
  // Check if the number starts with a "+" sign (for international numbers)
  if (phoneNumber.startsWith("+") && phoneNumber.length < 11) {
    return false;
  }
  return true;
}

export function phoneNumberIsDifferent(originalNumber: string, newNumber: string): boolean {
  if (!newNumber) {
    return false;
  }

  //sanitize phone numbers by removing spaces
  const sanitizedOriginalNumber = originalNumber.replace(/\s/g, '');
  const sanitizedNewNumber = newNumber.replace(/\s/g, '');

  //will return true if numbers are different
  return sanitizedOriginalNumber !== sanitizedNewNumber;
}

export const listOfCountries = [
    {
      "ISOCountryCode": "AF",
      "name": "Afghanistan",
      "dialCode": "93"
    },
    {
      "ISOCountryCode": "AL",
      "name": "Albania",
      "dialCode": "355"
    },
    {
      "ISOCountryCode": "DZ",
      "name": "Algeria",
      "dialCode": "213"
    },
    {
      "ISOCountryCode": "AS",
      "name": "American Samoa",
      "dialCode": "1684"
    },
    {
      "ISOCountryCode": "AD",
      "name": "Andorra",
      "dialCode": "376"
    },
    {
      "ISOCountryCode": "AO",
      "name": "Angola",
      "dialCode": "244"
    },
    {
      "ISOCountryCode": "AI",
      "name": "Anguilla",
      "dialCode": "1264"
    },
    {
      "ISOCountryCode": "AG",
      "name": "Antigua & Barbuda",
      "dialCode": "1268"
    },
    {
      "ISOCountryCode": "AR",
      "name": "Argentina",
      "dialCode": "54"
    },
    {
      "ISOCountryCode": "AM",
      "name": "Armenia",
      "dialCode": "374"
    },
    {
      "ISOCountryCode": "AW",
      "name": "Aruba",
      "dialCode": "297"
    },
    {
      "ISOCountryCode": "AC",
      "name": "Ascension Island",
      "dialCode": "247"
    },
    {
      "ISOCountryCode": "AU",
      "name": "Australia",
      "dialCode": "61"
    },
    {
      "ISOCountryCode": "AT",
      "name": "Austria",
      "dialCode": "43"
    },
    {
      "ISOCountryCode": "AZ",
      "name": "Azerbaijan",
      "dialCode": "994"
    },
    {
      "ISOCountryCode": "BS",
      "name": "Bahamas",
      "dialCode": "1242"
    },
    {
      "ISOCountryCode": "BH",
      "name": "Bahrain",
      "dialCode": "973"
    },
    {
      "ISOCountryCode": "BD",
      "name": "Bangladesh",
      "dialCode": "880"
    },
    {
      "ISOCountryCode": "BB",
      "name": "Barbados",
      "dialCode": "1246"
    },
    {
      "ISOCountryCode": "BY",
      "name": "Belarus",
      "dialCode": "375"
    },
    {
      "ISOCountryCode": "BE",
      "name": "Belgium",
      "dialCode": "32"
    },
    {
      "ISOCountryCode": "BZ",
      "name": "Belize",
      "dialCode": "501"
    },
    {
      "ISOCountryCode": "BJ",
      "name": "Benin",
      "dialCode": "229"
    },
    {
      "ISOCountryCode": "BM",
      "name": "Bermuda",
      "dialCode": "1441"
    },
    {
      "ISOCountryCode": "BT",
      "name": "Bhutan",
      "dialCode": "975"
    },
    {
      "ISOCountryCode": "BO",
      "name": "Bolivia",
      "dialCode": "591"
    },
    {
      "ISOCountryCode": "BA",
      "name": "Bosnia & Herzegovina",
      "dialCode": "387"
    },
    {
      "ISOCountryCode": "BW",
      "name": "Botswana",
      "dialCode": "267"
    },
    {
      "ISOCountryCode": "BR",
      "name": "Brazil",
      "dialCode": "55"
    },
    {
      "ISOCountryCode": "IO",
      "name": "British Indian Ocean Territory",
      "dialCode": "246"
    },
    {
      "ISOCountryCode": "VG",
      "name": "British Virgin Islands",
      "dialCode": "1284"
    },
    {
      "ISOCountryCode": "BN",
      "name": "Brunei",
      "dialCode": "673"
    },
    {
      "ISOCountryCode": "BG",
      "name": "Bulgaria",
      "dialCode": "359"
    },
    {
      "ISOCountryCode": "BF",
      "name": "Burkina Faso",
      "dialCode": "226"
    },
    {
      "ISOCountryCode": "BI",
      "name": "Burundi",
      "dialCode": "257"
    },
    {
      "ISOCountryCode": "KH",
      "name": "Cambodia",
      "dialCode": "855"
    },
    {
      "ISOCountryCode": "CM",
      "name": "Cameroon",
      "dialCode": "237"
    },
    {
      "ISOCountryCode": "CA",
      "name": "Canada",
      "dialCode": "1"
    },
    {
      "ISOCountryCode": "CV",
      "name": "Cape Verde",
      "dialCode": "238"
    },
    {
      "ISOCountryCode": "BQ",
      "name": "Caribbean Netherlands",
      "dialCode": "599"
    },
    {
      "ISOCountryCode": "KY",
      "name": "Cayman Islands",
      "dialCode": "1345"
    },
    {
      "ISOCountryCode": "CF",
      "name": "Central African Republic",
      "dialCode": "236"
    },
    {
      "ISOCountryCode": "TD",
      "name": "Chad",
      "dialCode": "235"
    },
    {
      "ISOCountryCode": "CL",
      "name": "Chile",
      "dialCode": "56"
    },
    {
      "ISOCountryCode": "CN",
      "name": "China",
      "dialCode": "86"
    },
    {
      "ISOCountryCode": "CX",
      "name": "Christmas Island",
      "dialCode": "61"
    },
    {
      "ISOCountryCode": "CC",
      "name": "Cocos (Keeling) Islands",
      "dialCode": "61"
    },
    {
      "ISOCountryCode": "CO",
      "name": "Colombia",
      "dialCode": "57"
    },
    {
      "ISOCountryCode": "KM",
      "name": "Comoros",
      "dialCode": "269"
    },
    {
      "ISOCountryCode": "CD",
      "name": "Congo - Kinshasa",
      "dialCode": "243"
    },
    {
      "ISOCountryCode": "CG",
      "name": "Congo - Brazzaville",
      "dialCode": "242"
    },
    {
      "ISOCountryCode": "CK",
      "name": "Cook Islands",
      "dialCode": "682"
    },
    {
      "ISOCountryCode": "CR",
      "name": "Costa Rica",
      "dialCode": "506"
    },
    {
      "ISOCountryCode": "HR",
      "name": "Croatia",
      "dialCode": "385"
    },
    {
      "ISOCountryCode": "CU",
      "name": "Cuba",
      "dialCode": "53"
    },
    {
      "ISOCountryCode": "CW",
      "name": "Curaçao",
      "dialCode": "599"
    },
    {
      "ISOCountryCode": "CY",
      "name": "Cyprus",
      "dialCode": "357"
    },
    {
      "ISOCountryCode": "CZ",
      "name": "Czechia",
      "dialCode": "420"
    },
    {
      "ISOCountryCode": "CI",
      "name": "Côte d'Ivoire",
      "dialCode": "225"
    },
    {
      "ISOCountryCode": "DK",
      "name": "Denmark",
      "dialCode": "45"
    },
    {
      "ISOCountryCode": "DJ",
      "name": "Djibouti",
      "dialCode": "253"
    },
    {
      "ISOCountryCode": "DM",
      "name": "Dominica",
      "dialCode": "1767"
    },
    {
      "ISOCountryCode": "DO",
      "name": "Dominican Republic",
      "dialCode": "1"
    },
    {
      "ISOCountryCode": "EC",
      "name": "Ecuador",
      "dialCode": "593"
    },
    {
      "ISOCountryCode": "EG",
      "name": "Egypt",
      "dialCode": "20"
    },
    {
      "ISOCountryCode": "SV",
      "name": "El Salvador",
      "dialCode": "503"
    },
    {
      "ISOCountryCode": "GQ",
      "name": "Equatorial Guinea",
      "dialCode": "240"
    },
    {
      "ISOCountryCode": "ER",
      "name": "Eritrea",
      "dialCode": "291"
    },
    {
      "ISOCountryCode": "EE",
      "name": "Estonia",
      "dialCode": "372"
    },
    {
      "ISOCountryCode": "ET",
      "name": "Ethiopia",
      "dialCode": "251"
    },
    {
      "ISOCountryCode": "FK",
      "name": "Falkland Islands",
      "dialCode": "500"
    },
    {
      "ISOCountryCode": "FO",
      "name": "Faroe Islands",
      "dialCode": "298"
    },
    {
      "ISOCountryCode": "FJ",
      "name": "Fiji",
      "dialCode": "679"
    },
    {
      "ISOCountryCode": "FI",
      "name": "Finland",
      "dialCode": "358"
    },
    {
      "ISOCountryCode": "FR",
      "name": "France",
      "dialCode": "33"
    },
    {
      "ISOCountryCode": "GF",
      "name": "French Guiana",
      "dialCode": "594"
    },
    {
      "ISOCountryCode": "PF",
      "name": "French Polynesia",
      "dialCode": "689"
    },
    {
      "ISOCountryCode": "GA",
      "name": "Gabon",
      "dialCode": "241"
    },
    {
      "ISOCountryCode": "GM",
      "name": "Gambia",
      "dialCode": "220"
    },
    {
      "ISOCountryCode": "GE",
      "name": "Georgia",
      "dialCode": "995"
    },
    {
      "ISOCountryCode": "DE",
      "name": "Germany",
      "dialCode": "49"
    },
    {
      "ISOCountryCode": "GH",
      "name": "Ghana",
      "dialCode": "233"
    },
    {
      "ISOCountryCode": "GI",
      "name": "Gibraltar",
      "dialCode": "350"
    },
    {
      "ISOCountryCode": "GR",
      "name": "Greece",
      "dialCode": "30"
    },
    {
      "ISOCountryCode": "GL",
      "name": "Greenland",
      "dialCode": "299"
    },
    {
      "ISOCountryCode": "GD",
      "name": "Grenada",
      "dialCode": "1473"
    },
    {
      "ISOCountryCode": "GP",
      "name": "Guadeloupe",
      "dialCode": "590"
    },
    {
      "ISOCountryCode": "GU",
      "name": "Guam",
      "dialCode": "1671"
    },
    {
      "ISOCountryCode": "GT",
      "name": "Guatemala",
      "dialCode": "502"
    },
    {
      "ISOCountryCode": "GG",
      "name": "Guernsey",
      "dialCode": "44"
    },
    {
      "ISOCountryCode": "GN",
      "name": "Guinea",
      "dialCode": "224"
    },
    {
      "ISOCountryCode": "GW",
      "name": "Guinea-Bissau",
      "dialCode": "245"
    },
    {
      "ISOCountryCode": "GY",
      "name": "Guyana",
      "dialCode": "592"
    },
    {
      "ISOCountryCode": "HT",
      "name": "Haiti",
      "dialCode": "509"
    },
    {
      "ISOCountryCode": "HN",
      "name": "Honduras",
      "dialCode": "504"
    },
    {
      "ISOCountryCode": "HK",
      "name": "Hong Kong",
      "dialCode": "852"
    },
    {
      "ISOCountryCode": "HU",
      "name": "Hungary",
      "dialCode": "36"
    },
    {
      "ISOCountryCode": "IS",
      "name": "Iceland",
      "dialCode": "354"
    },
    {
      "ISOCountryCode": "IN",
      "name": "India",
      "dialCode": "91"
    },
    {
      "ISOCountryCode": "ID",
      "name": "Indonesia",
      "dialCode": "62"
    },
    {
      "ISOCountryCode": "IR",
      "name": "Iran",
      "dialCode": "98"
    },
    {
      "ISOCountryCode": "IQ",
      "name": "Iraq",
      "dialCode": "964"
    },
    {
      "ISOCountryCode": "IE",
      "name": "Ireland",
      "dialCode": "353"
    },
    {
      "ISOCountryCode": "IM",
      "name": "Isle of Man",
      "dialCode": "44"
    },
    {
      "ISOCountryCode": "IL",
      "name": "Israel",
      "dialCode": "972"
    },
    {
      "ISOCountryCode": "IT",
      "name": "Italy",
      "dialCode": "39"
    },
    {
      "ISOCountryCode": "JM",
      "name": "Jamaica",
      "dialCode": "1876"
    },
    {
      "ISOCountryCode": "JP",
      "name": "Japan",
      "dialCode": "81"
    },
    {
      "ISOCountryCode": "JE",
      "name": "Jersey",
      "dialCode": "44"
    },
    {
      "ISOCountryCode": "JO",
      "name": "Jordan",
      "dialCode": "962"
    },
    {
      "ISOCountryCode": "KZ",
      "name": "Kazakhstan",
      "dialCode": "7"
    },
    {
      "ISOCountryCode": "KE",
      "name": "Kenya",
      "dialCode": "254"
    },
    {
      "ISOCountryCode": "KI",
      "name": "Kiribati",
      "dialCode": "686"
    },
    {
      "ISOCountryCode": "XK",
      "name": "Kosovo",
      "dialCode": "383"
    },
    {
      "ISOCountryCode": "KW",
      "name": "Kuwait",
      "dialCode": "965"
    },
    {
      "ISOCountryCode": "KG",
      "name": "Kyrgyzstan",
      "dialCode": "996"
    },
    {
      "ISOCountryCode": "LA",
      "name": "Laos",
      "dialCode": "856"
    },
    {
      "ISOCountryCode": "LV",
      "name": "Latvia",
      "dialCode": "371"
    },
    {
      "ISOCountryCode": "LB",
      "name": "Lebanon",
      "dialCode": "961"
    },
    {
      "ISOCountryCode": "LS",
      "name": "Lesotho",
      "dialCode": "266"
    },
    {
      "ISOCountryCode": "LR",
      "name": "Liberia",
      "dialCode": "231"
    },
    {
      "ISOCountryCode": "LY",
      "name": "Libya",
      "dialCode": "218"
    },
    {
      "ISOCountryCode": "LI",
      "name": "Liechtenstein",
      "dialCode": "423"
    },
    {
      "ISOCountryCode": "LT",
      "name": "Lithuania",
      "dialCode": "370"
    },
    {
      "ISOCountryCode": "LU",
      "name": "Luxembourg",
      "dialCode": "352"
    },
    {
      "ISOCountryCode": "MO",
      "name": "Macau",
      "dialCode": "853"
    },
    {
      "ISOCountryCode": "MK",
      "name": "North Macedonia",
      "dialCode": "389"
    },
    {
      "ISOCountryCode": "MG",
      "name": "Madagascar",
      "dialCode": "261"
    },
    {
      "ISOCountryCode": "MW",
      "name": "Malawi",
      "dialCode": "265"
    },
    {
      "ISOCountryCode": "MY",
      "name": "Malaysia",
      "dialCode": "60"
    },
    {
      "ISOCountryCode": "MV",
      "name": "Maldives",
      "dialCode": "960"
    },
    {
      "ISOCountryCode": "ML",
      "name": "Mali",
      "dialCode": "223"
    },
    {
      "ISOCountryCode": "MT",
      "name": "Malta",
      "dialCode": "356"
    },
    {
      "ISOCountryCode": "MH",
      "name": "Marshall Islands",
      "dialCode": "692"
    },
    {
      "ISOCountryCode": "MQ",
      "name": "Martinique",
      "dialCode": "596"
    },
    {
      "ISOCountryCode": "MR",
      "name": "Mauritania",
      "dialCode": "222"
    },
    {
      "ISOCountryCode": "MU",
      "name": "Mauritius",
      "dialCode": "230"
    },
    {
      "ISOCountryCode": "YT",
      "name": "Mayotte",
      "dialCode": "262"
    },
    {
      "ISOCountryCode": "MX",
      "name": "Mexico",
      "dialCode": "52"
    },
    {
      "ISOCountryCode": "FM",
      "name": "Micronesia",
      "dialCode": "691"
    },
    {
      "ISOCountryCode": "MD",
      "name": "Moldova",
      "dialCode": "373"
    },
    {
      "ISOCountryCode": "MC",
      "name": "Monaco",
      "dialCode": "377"
    },
    {
      "ISOCountryCode": "MN",
      "name": "Mongolia",
      "dialCode": "976"
    },
    {
      "ISOCountryCode": "ME",
      "name": "Montenegro",
      "dialCode": "382"
    },
    {
      "ISOCountryCode": "MS",
      "name": "Montserrat",
      "dialCode": "1664"
    },
    {
      "ISOCountryCode": "MA",
      "name": "Morocco",
      "dialCode": "212"
    },
    {
      "ISOCountryCode": "MZ",
      "name": "Mozambique",
      "dialCode": "258"
    },
    {
      "ISOCountryCode": "MM",
      "name": "Myanmar",
      "dialCode": "95"
    },
    {
      "ISOCountryCode": "NA",
      "name": "Namibia",
      "dialCode": "264"
    },
    {
      "ISOCountryCode": "NR",
      "name": "Nauru",
      "dialCode": "674"
    },
    {
      "ISOCountryCode": "NP",
      "name": "Nepal",
      "dialCode": "977"
    },
    {
      "ISOCountryCode": "NL",
      "name": "Netherlands",
      "dialCode": "31"
    },
    {
      "ISOCountryCode": "NC",
      "name": "New Caledonia",
      "dialCode": "687"
    },
    {
      "ISOCountryCode": "NZ",
      "name": "New Zealand",
      "dialCode": "64"
    },
    {
      "ISOCountryCode": "NI",
      "name": "Nicaragua",
      "dialCode": "505"
    },
    {
      "ISOCountryCode": "NE",
      "name": "Niger",
      "dialCode": "227"
    },
    {
      "ISOCountryCode": "NG",
      "name": "Nigeria",
      "dialCode": "234"
    },
    {
      "ISOCountryCode": "NU",
      "name": "Niue",
      "dialCode": "683"
    },
    {
      "ISOCountryCode": "NF",
      "name": "Norfolk Island",
      "dialCode": "672"
    },
    {
      "ISOCountryCode": "KP",
      "name": "North Korea",
      "dialCode": "850"
    },
    {
      "ISOCountryCode": "MP",
      "name": "Northern Mariana Islands",
      "dialCode": "1670"
    },
    {
      "ISOCountryCode": "NO",
      "name": "Norway",
      "dialCode": "47"
    },
    {
      "ISOCountryCode": "OM",
      "name": "Oman",
      "dialCode": "968"
    },
    {
      "ISOCountryCode": "PK",
      "name": "Pakistan",
      "dialCode": "92"
    },
    {
      "ISOCountryCode": "PW",
      "name": "Palau",
      "dialCode": "680"
    },
    {
      "ISOCountryCode": "PS",
      "name": "Palestine",
      "dialCode": "970"
    },
    {
      "ISOCountryCode": "PA",
      "name": "Panama",
      "dialCode": "507"
    },
    {
      "ISOCountryCode": "PG",
      "name": "Papua New Guinea",
      "dialCode": "675"
    },
    {
      "ISOCountryCode": "PY",
      "name": "Paraguay",
      "dialCode": "595"
    },
    {
      "ISOCountryCode": "PE",
      "name": "Peru",
      "dialCode": "51"
    },
    {
      "ISOCountryCode": "PH",
      "name": "Philippines",
      "dialCode": "63"
    },
    {
      "ISOCountryCode": "PL",
      "name": "Poland",
      "dialCode": "48"
    },
    {
      "ISOCountryCode": "PT",
      "name": "Portugal",
      "dialCode": "351"
    },
    {
      "ISOCountryCode": "PR",
      "name": "Puerto Rico",
      "dialCode": "1"
    },
    {
      "ISOCountryCode": "QA",
      "name": "Qatar",
      "dialCode": "974"
    },
    {
      "ISOCountryCode": "RO",
      "name": "Romania",
      "dialCode": "40"
    },
    {
      "ISOCountryCode": "RU",
      "name": "Russia",
      "dialCode": "7"
    },
    {
      "ISOCountryCode": "RW",
      "name": "Rwanda",
      "dialCode": "250"
    },
    {
      "ISOCountryCode": "RE",
      "name": "Réunion",
      "dialCode": "262"
    },
    {
      "ISOCountryCode": "BL",
      "name": "Saint Barthélemy",
      "dialCode": "590"
    },
    {
      "ISOCountryCode": "SH",
      "name": "Saint Helena",
      "dialCode": "290"
    },
    {
      "ISOCountryCode": "KN",
      "name": "Saint Kitts & Nevis",
      "dialCode": "1869"
    },
    {
      "ISOCountryCode": "LC",
      "name": "Saint Lucia",
      "dialCode": "1758"
    },
    {
      "ISOCountryCode": "MF",
      "name": "Saint Martin",
      "dialCode": "590"
    },
    {
      "ISOCountryCode": "PM",
      "name": "Saint Pierre & Miquelon",
      "dialCode": "508"
    },
    {
      "ISOCountryCode": "VC",
      "name": "Saint Vincent & the Grenadines",
      "dialCode": "1784"
    },
    {
      "ISOCountryCode": "WS",
      "name": "Samoa",
      "dialCode": "685"
    },
    {
      "ISOCountryCode": "SM",
      "name": "San Marino",
      "dialCode": "378"
    },
    {
      "ISOCountryCode": "SA",
      "name": "Saudi Arabia",
      "dialCode": "966"
    },
    {
      "ISOCountryCode": "SN",
      "name": "Senegal",
      "dialCode": "221"
    },
    {
      "ISOCountryCode": "RS",
      "name": "Serbia",
      "dialCode": "381"
    },
    {
      "ISOCountryCode": "SC",
      "name": "Seychelles",
      "dialCode": "248"
    },
    {
      "ISOCountryCode": "SL",
      "name": "Sierra Leone",
      "dialCode": "232"
    },
    {
      "ISOCountryCode": "SG",
      "name": "Singapore",
      "dialCode": "65"
    },
    {
      "ISOCountryCode": "SX",
      "name": "Sint Maarten",
      "dialCode": "1721"
    },
    {
      "ISOCountryCode": "SK",
      "name": "Slovakia",
      "dialCode": "421"
    },
    {
      "ISOCountryCode": "SI",
      "name": "Slovenia",
      "dialCode": "386"
    },
    {
      "ISOCountryCode": "SB",
      "name": "Solomon Islands",
      "dialCode": "677"
    },
    {
      "ISOCountryCode": "SO",
      "name": "Somalia",
      "dialCode": "252"
    },
    {
      "ISOCountryCode": "ZA",
      "name": "South Africa",
      "dialCode": "27"
    },
    {
      "ISOCountryCode": "KR",
      "name": "South Korea",
      "dialCode": "82"
    },
    {
      "ISOCountryCode": "SS",
      "name": "South Sudan",
      "dialCode": "211"
    },
    {
      "ISOCountryCode": "ES",
      "name": "Spain",
      "dialCode": "34"
    },
    {
      "ISOCountryCode": "LK",
      "name": "Sri Lanka",
      "dialCode": "94"
    },
    {
      "ISOCountryCode": "SD",
      "name": "Sudan",
      "dialCode": "249"
    },
    {
      "ISOCountryCode": "SR",
      "name": "Suriname",
      "dialCode": "597"
    },
    {
      "ISOCountryCode": "SJ",
      "name": "Svalbard & Jan Mayen",
      "dialCode": "47"
    },
    {
      "ISOCountryCode": "SZ",
      "name": "Eswatini",
      "dialCode": "268"
    },
    {
      "ISOCountryCode": "SE",
      "name": "Sweden",
      "dialCode": "46"
    },
    {
      "ISOCountryCode": "CH",
      "name": "Switzerland",
      "dialCode": "41"
    },
    {
      "ISOCountryCode": "SY",
      "name": "Syria",
      "dialCode": "963"
    },
    {
      "ISOCountryCode": "ST",
      "name": "São Tomé & Príncipe",
      "dialCode": "239"
    },
    {
      "ISOCountryCode": "TW",
      "name": "Taiwan",
      "dialCode": "886"
    },
    {
      "ISOCountryCode": "TJ",
      "name": "Tajikistan",
      "dialCode": "992"
    },
    {
      "ISOCountryCode": "TZ",
      "name": "Tanzania",
      "dialCode": "255"
    },
    {
      "ISOCountryCode": "TH",
      "name": "Thailand",
      "dialCode": "66"
    },
    {
      "ISOCountryCode": "TL",
      "name": "Timor-Leste",
      "dialCode": "670"
    },
    {
      "ISOCountryCode": "TG",
      "name": "Togo",
      "dialCode": "228"
    },
    {
      "ISOCountryCode": "TK",
      "name": "Tokelau",
      "dialCode": "690"
    },
    {
      "ISOCountryCode": "TO",
      "name": "Tonga",
      "dialCode": "676"
    },
    {
      "ISOCountryCode": "TT",
      "name": "Trinidad & Tobago",
      "dialCode": "1868"
    },
    {
      "ISOCountryCode": "TA",
      "name": "Tristan da Cunha",
      "dialCode": "290"
    },
    {
      "ISOCountryCode": "TN",
      "name": "Tunisia",
      "dialCode": "216"
    },
    {
      "ISOCountryCode": "TR",
      "name": "Türkiye",
      "dialCode": "90"
    },
    {
      "ISOCountryCode": "TM",
      "name": "Turkmenistan",
      "dialCode": "993"
    },
    {
      "ISOCountryCode": "TC",
      "name": "Turks & Caicos Islands",
      "dialCode": "1649"
    },
    {
      "ISOCountryCode": "TV",
      "name": "Tuvalu",
      "dialCode": "688"
    },
    {
      "ISOCountryCode": "VI",
      "name": "U.S. Virgin Islands",
      "dialCode": "1340"
    },
    {
      "ISOCountryCode": "UG",
      "name": "Uganda",
      "dialCode": "256"
    },
    {
      "ISOCountryCode": "UA",
      "name": "Ukraine",
      "dialCode": "380"
    },
    {
      "ISOCountryCode": "AE",
      "name": "United Arab Emirates",
      "dialCode": "971"
    },
    {
      "ISOCountryCode": "GB",
      "name": "United Kingdom",
      "dialCode": "44"
    },
    {
      "ISOCountryCode": "US",
      "name": "United States",
      "dialCode": "1"
    },
    {
      "ISOCountryCode": "UY",
      "name": "Uruguay",
      "dialCode": "598"
    },
    {
      "ISOCountryCode": "UZ",
      "name": "Uzbekistan",
      "dialCode": "998"
    },
    {
      "ISOCountryCode": "VU",
      "name": "Vanuatu",
      "dialCode": "678"
    },
    {
      "ISOCountryCode": "VA",
      "name": "Vatican City",
      "dialCode": "39"
    },
    {
      "ISOCountryCode": "VE",
      "name": "Venezuela",
      "dialCode": "58"
    },
    {
      "ISOCountryCode": "VN",
      "name": "Vietnam",
      "dialCode": "84"
    },
    {
      "ISOCountryCode": "WF",
      "name": "Wallis & Futuna",
      "dialCode": "681"
    },
    {
      "ISOCountryCode": "EH",
      "name": "Western Sahara",
      "dialCode": "212"
    },
    {
      "ISOCountryCode": "YE",
      "name": "Yemen",
      "dialCode": "967"
    },
    {
      "ISOCountryCode": "ZM",
      "name": "Zambia",
      "dialCode": "260"
    },
    {
      "ISOCountryCode": "ZW",
      "name": "Zimbabwe",
      "dialCode": "263"
    },
    {
      "ISOCountryCode": "AX",
      "name": "Åland Islands",
      "dialCode": "358"
    }
  ]


export function listOfCountriesToFilterOptions(localisedCountryNames) {
  return listOfCountries.map(country => {
    return {value: country.ISOCountryCode, label: `${getFlagEmoji(country.ISOCountryCode)} ${getCountryLocalisedCountryName(localisedCountryNames, country.ISOCountryCode, country.name)} (+${country.dialCode})`}
  })
}

export function getFlagEmoji(code:string) {
  const codePoints = code
    .toUpperCase()
    .split('')
    .map((char: string) =>  127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

export function getCountryDataFromCode(isoCode: string){
  return listOfCountries.find(el => el.ISOCountryCode === isoCode)
}

function getCountryLocalisedCountryName(localisedCountrynames: {[key: string]: string}, isoCode:string, defaultCountryName: string) {
  if(localisedCountrynames[`Countries.${isoCode}`]) {
    return localisedCountrynames[`Countries.${isoCode}`]
  }

  return defaultCountryName
}

export function getLocationBestGuess() {
  const location = navigator.language?.split("-")[1] || 'GB';
  const prefix = listOfCountries.find(c => c.ISOCountryCode === location).dialCode

  return {location, prefix}

}